module.exports = __webpack_public_path__ + "img/bk_purple1.06816ad6.png";